export default {
  set(state, payload) {
    state.items = payload[0];
  },
};
